<section class="container-wrapper">
    <h1 class="module-heading">{{ 'pages.config-all.config-family.heading' | translate }}</h1>
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    </div>
    <div *ngIf="!loading" [formGroup]="familyConfigInstructionForm">
      <section>
  
        <app-form-input class="maxWidth-350" label="{{'pages.config-all.config-family.proofOfIdentityCountLabel' | translate}}" formControlName="proofOfIdentityCount" data-cy="proofOfIdentityCount">
          <app-form-error *ngIf="proofOfIdentityCount.touched && proofOfIdentityCount.hasError('required')">
            {{'pages.config-all.config-family.errors.requiredProofOfIdentityCount' | translate}}
          </app-form-error>
          <app-form-error *ngIf="proofOfIdentityCount.touched && (proofOfIdentityCount.hasError('pattern') || proofOfIdentityCount.hasError('max'))">
            {{'pages.config-all.config-family.errors.invalidProofOfIdentityCount' | translate}}
          </app-form-error>
        </app-form-input>
  
        <app-bciti-tabs [badges]="badges">
          <app-bciti-tab *ngFor="let language of langs; let i = index" [title]="'pages.config-all.config-family.langs.' + language | translate">
            <div *ngFor="let availableTextConfig of availableTextConfigs" class="mtb-10">
              <h4 class="m-0">{{ 'pages.config-all.config-family.' + availableTextConfig + 'Label' | translate }}</h4>
              <quill-editor class="w-100" [formControlName]="language + '-' + availableTextConfig" [placeholder]="'pages.config-all.config-family.' + availableTextConfig + 'Placeholder.' + language | translate">
                <div quill-editor-toolbar>
                    <span class="ql-formats">
                        <select class="ql-font">
                          <option selected></option>
                          <option value="serif"></option>
                          <option value="monospace"></option>
                        </select>
                        <select class="ql-size">
                          <option value="small"></option>
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-header" value="1"></button>
                        <button class="ql-header" value="2"></button>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                        <button class="ql-underline"></button>
                        <button class="ql-strike"></button>
                        <button class="ql-link"></button>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-code-block"></button>
                        <button class="ql-blockquote"></button>
                      </span>
                      <span class="ql-formats">
                        <select class="ql-color"></select>
                        <select class="ql-background"></select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select class="ql-align">
                          <option selected></option>
                          <option value="center"></option>
                          <option value="right"></option>
                          <option value="justify"></option>
                        </select>
                      </span>
                  </div>
              </quill-editor>
            </div>
          </app-bciti-tab>
        </app-bciti-tabs>
      </section>
      <div class="row justify-end">
        <button class="bciti-button" [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--red'" (click)="cancel()"
          [disabled]="processingSubmit">
          <span>{{ 'pages.config-all.config-family.button.cancel' | translate }}</span>
        </button>
        <button class="bciti-button ml-10" [ngClass]="!validateForm() || processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'" (click)="submit()"
          [disabled]="!validateForm() || processingSubmit">
          <span class="submit-loader">{{ 'pages.config-all.config-family.button.submit' | translate }} <mat-spinner diameter="20" *ngIf="processingSubmit"></mat-spinner></span>
        </button>
      </div>
      <app-denial-reasons-table
        [group]="'family'"
        [denialReasons]="orgConfig?.family?.denialReasons"
        [langs]="langs"
        [orgTag]="org?.tag"
        [sectionLabel]="'pages.config-all.denial-reasons.sections.family' | translate">
      </app-denial-reasons-table>
    </div>
  </section>